module.exports = __webpack_public_path__ + "img/Busy_Corner@3x.ecb854e7.png";